<template>
    <div class="elder-basic">
        <mt-header fixed title="基本信息编辑">
            <router-link :to="'/elder/'+id" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="elder-form">

            <mt-field label="*姓名" placeholder="请输入姓名" v-model="name"></mt-field>

            <mint-select selectLabel="*性别" selectPatch="sex" :selectValue="sex" :slots="sexSlots" @changeValue="changeValue"></mint-select>
            <mint-select selectLabel="*民族" selectPatch="nation" :selectValue="nation" :slots="nationSlots" @changeValue="changeValue"></mint-select>

            <mint-select selectLabel="*身份证件类型" selectPatch="id_type" :selectValue="id_type" :slots="idTypeSlots" @changeValue="changeValue"></mint-select>
            <mt-field label="*身份证件号码" placeholder="请输入身份证件号码" v-model="id_number"></mt-field>

            <mt-field label="*出生日期" placeholder="请输入出生日期" type="date" v-model="birthday"></mt-field>

            <region-bar v-if="default_address" regionLabel="*户籍地址" @getAddress="getAddress" regionPatch="default_address"
                        :province="default_address[0]" :city="default_address[1]" :country="default_address[2]" :town="default_address[3]" :village="default_address[4]" :address="default_address[5]"></region-bar>

            <region-bar v-if="live_address" regionLabel="*居住地址" @getAddress="getAddress" regionPatch="live_address"
                        :province="live_address[0]" :city="live_address[1]" :country="live_address[2]" :town="live_address[3]" :village="live_address[4]" :address="live_address[5]"></region-bar>

            <mt-field label="身份证有效期" placeholder="请输入身份证有效期" v-model="id_number_validity"></mt-field>
            <mt-field label="发证机关" placeholder="请输入发证机关" v-model="id_number_gov"></mt-field>

            <mint-select selectLabel="*婚姻状况" selectPatch="marriage" :selectValue="marriage" :slots="marriageSlots" @changeValue="changeValue"></mint-select>
            <mint-select selectLabel="宗教信仰" selectPatch="religion" :selectValue="religion" :slots="religionSlots" @changeValue="changeValue"></mint-select>
            <mt-field label="*联系电话" placeholder="请输入联系电话" type="number" v-model="phone"></mt-field>
            <mt-field label="其他号码" placeholder="多个电话请用英文,隔开"  v-model="other_phone"></mt-field>


            <mint-select selectLabel="*政府补偿" selectPatch="allowance" :selectValue="allowance" :slots="allowanceSlots" @changeValue="changeValue"></mint-select>
            <mint-select selectLabel="*老人分类" selectPatch="elder_type" :selectValue="elder_type" :slots="elderTypeSlots" @changeValue="changeValue"></mint-select>
            <mt-checklist title="*居住情况" v-model="live_status" :options="liveStatusOptions"></mt-checklist>

            <div class="new-form-button">
                <mt-button size="large" type="primary" @click="updateElder">提交</mt-button>
            </div>
        </div>
    </div>
</template>
<script>
    import Region from '../../components/region.vue'
    import mintSelect from '../../components/mintSelect.vue'

    export default{
        components: {
            'region-bar': Region,
            'mint-select':mintSelect
        },

        data(){
            return {
                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,
                id:this.$route.params.id,
                name:'',
                birthday:'',
                id_number:'',

                choose:{
                    'nation':false,
                    'sex':false
                },

                nation:'汉族',
                nationSlots: [
                    {
                        values: [],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],

                sex:'男',
                sexSlots: [
                    {
                        values: ['男','女'],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],

                id_type:'居民身份证',
                idTypeSlots: [
                    {
                        values: [],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],

                marriage : '已婚',
                marriageSlots: [
                    {
                        values: [],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],

                religion : '',
                religionSlots: [
                    {
                        values: [],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],

                default_address:this.default_address,
                live_address:this.live_address,

                phone:'',
                other_phone:'',
                id_number_gov:'',
                id_number_validity:'',

                allowance:'无偿',
                allowanceSlots: [
                    {
                        values: [],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],

                elder_type:'',
                elderTypeSlots: [
                    {
                        values: [],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],

                live_status:[],
                liveStatusOptions:[],
            }
        },

        created(){

            this.$axios.post("/elder/option", {openid:this.openid})
                .then(data => {

                    if (data.data.code === 'OK') {
                        this.nationSlots[0].values = data.data.data.nation;
                        this.marriageSlots[0].values = data.data.data.marriage;
                        this.religionSlots[0].values = data.data.data.religion;
                        this.allowanceSlots[0].values = data.data.data.allowance;
                        this.elderTypeSlots[0].values = data.data.data.elder_type;
                        this.idTypeSlots[0].values = data.data.data.id_type;


                        var live_status_array = Array();
                        for(let i=0;i<data.data.data.live_status.length;i++){
                            live_status_array[i] = { label:data.data.data.live_status[i],value:data.data.data.live_status[i]};
                        }
                        this.liveStatusOptions = live_status_array;

                    } else {
                        this.$toast(data.data.message);
                    }
                });

            this.$axios.get('/elder/basic?openid='+this.openid+'&elder='+this.id)
                .then(data => {

                    if (data.data.code === 'OK') {
                        let r = data.data.data;
                        this.name = r.name;
                        this.sex = r.sex;
                        this.nation = r.nation;
                        this.id_type = r.id_type;
                        this.id_number = r.id_number;
                        this.birthday = r.birthday;
                        this.default_address = [r.province_id,r.city_id,r.country_id,r.town_id,r.village_id,r.address];
                        this.live_address = [r.live_province_id,r.live_city_id,r.live_country_id,r.live_town_id,r.live_village_id,r.live_address];
                        this.marriage = r.marriage;
                        this.religion = r.religion;
                        this.phone = r.phone;
                        this.other_phone = r.other_phone;
                        this.id_number_validity = r.id_number_validity;
                        this.id_number_gov = r.id_number_gov;
                        this.allowance = r.allowance;console.log(r.elder_type);
                        this.elder_type = r.elder_type;
                        this.live_status =  r.live_status.split(',');
                    } else {
                        this.$toast(data.data.message);
                    }
                });

        },

        methods:{

            //mini-select
            changeValue(value){
                let props = value[0];
                this[props] = value[1];
            },

            //region
            getAddress(value){
                let props = value[0];
                this[props] = value[1];
            },

            updateElder(){

                if(this.name===''||this.id_number===''||this.birthday===''||this.default_address[5]===''||this.live_address[5]===''||this.phone===''){
                    this.$toast('所有带*信息为必填项，请完善信息后添加');
                    return false;
                }

                if(!this.live_status.length>0){
                    this.$toast('请选择老人居住情况');
                    return false;
                }

                if(!this.elder_type.length>0){
                    this.$toast('请选择老人分类');
                    return false;
                }

                this.$indicator.open('加载中');

                this.$axios.post("/elder/basic", {openid:this.openid,elder:this.id,name:this.name,nation:this.nation,sex:this.sex,id_type:this.id_type,id_number:this.id_number,marriage:this.marriage,religion:this.religion,birthday:this.birthday,default_address:this.default_address,live_address:this.live_address,phone:this.phone,other_phone:this.other_phone,id_number_validity:this.id_number_validity,id_number_gov:this.id_number_gov,allowance:this.allowance,live_status:this.live_status,elder_type:this.elder_type})
                    .then(data => {

                        this.$indicator.close();

                        if (data.data.code === 'OK') {
                            this.$toast('修改成功!');
                       //     this.$router.push('/community');
                        } else {
                            this.$toast(data.data.message);
                        }
                    });
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/pages/elder/basic.vue